export default () => ({
  show: false,
  init() {
    const form = document.getElementById("addressSubmitForm").firstChild;
    if (form) {
      form.addEventListener("submit", (e) => {
        e.preventDefault();
        const redirectPath = "/account?view=my-profile";
        const formData = new FormData(form);

        fetch("/account/addresses", {
          method: "POST",
          body: formData,
        }).then(() => {
          window.location.href = redirectPath;
        });
      });
    }
  },
});
